import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceService } from '@shared/services';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeviceTypeInterceptor implements HttpInterceptor {
  constructor(
    private occEndpoints: OccEndpointsService,
    private deviceService: DeviceService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(this.occEndpoints.getBaseUrl())) {
      return this.deviceService.deviceType$.pipe(
        first(),
        switchMap((deviceType) => {
          request = request.clone({
            setParams: { deviceType },
          });

          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
